import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Subject, takeUntil, tap } from "rxjs";


@Component({
    selector: 'error-message',
    templateUrl: 'error-message.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ErrorMessageComponent implements OnInit, OnDestroy {

    error_msg: string;
    showCTA: boolean = true;

    private _destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute
    ) {}

    private createErrorMessage(errorId: string) {
        switch (errorId) {
            case '0': // network error
                return {
                    showCTA: false,
                    message: 'view.error.0_message'
                };

            case '403':
                return {
                    showCTA: true,
                    message: 'view.error.403_message'
                };

            default:
                return {
                    showCTA: true,
                    message: 'view.error.default_message'
                };
        }
    }

    ngOnInit() {

        this.route.params
            .pipe(
                tap(params => {
                    const viewParams = this.createErrorMessage(params['id']);
                    this.error_msg = viewParams.message;
                    this.showCTA = viewParams.showCTA;
                }),
                takeUntil(this._destroy$)
            ).subscribe();

    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

}
